import { RouteConfig } from 'vue-router';
import {
  BVLayout,
  Index,
  Error404,
  Login,
  EmailConfirmation,
  CalculatorLayout,
  Migration
} from '@ligo/bv-flow/components';
import { MIGRATION } from '@ligo/bv-flow/store';

import { servicesCard } from './ligo-services';

const routes: RouteConfig[] = [
  {
    path: '/questionnaire',
    component: BVLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: Index,
        props: (route) => ({
          access_token: route.query.access_token,
          client: route.query.client,
          expiry: route.query.expiry,
          uid: route.query.uid,
          new_product: route.query.new_product,
          redirect_url: route.query.redirect_url,
          servicesCard
        }),
        meta: {
          progressBarStep: 0
        }
      },
      // {
      //   path: 'bv',
      //   name: 'bv-home',
      //   component: BvIndex,
      //   props: (route) => ({
      //     access_token: route.query.access_token,
      //     client: route.query.client,
      //     expiry: route.query.expiry,
      //     uid: route.query.uid,
      //     new_product: route.query.new_product,
      //     redirect_url: route.query.redirect_url,
      //     servicesCard: bvServicesCard
      //   }),
      //   meta: {
      //     progressBarStep: 0
      //   }
      // },
      {
        path: 'login',
        name: 'login',
        component: Login,
        props: (route) => ({
          redirectUrl: route.query.redirect_url,
          productType: route.query.product_type
        }),
        meta: {
          progressBarStep: 0,
          customLayout: 'max-display-checkout'
        }
      },
      {
        path: 'confirmation',
        name: 'Confirmation',
        component: EmailConfirmation,
        props: (route) => ({
          redirectUrl: route.query.redirect_url,
          productType: route.query.product_type
        }),
        meta: {
          progressBarStep: 0,
          customLayout: 'max-display-checkout'
        }
      },
      {
        path: 'dutch-bv/:uid?',
        name: 'DutchBV',
        component: Migration
      },
      {
        path: 'english-bv/:uid?',
        name: 'EnglishBV',
        component: Migration
      },
      {
        path: 'holding/:uid?',
        name: 'Holding',
        component: Migration
      },
      {
        path: 'incorporate-holding/:uid?',
        name: 'IncorporateHolding',
        component: Migration
      },
      {
        path: 'omzetting/:uid?',
        name: 'Omzetting',
        component: Migration
      },
      {
        path: 'stichting/:uid?',
        name: 'Stichting',
        component: Migration
      },
      {
        path: 'anbi_stichting_oprichten/:uid?',
        name: 'AnbiStichting',
        component: Migration
      },
      {
        path: 'transfer_of_shares/:uid?',
        name: 'TransferOfShares',
        component: Migration
      },
      {
        path: ':slug/:uid/billing',
        name: 'BillingInformation',
        component: Migration
      },
      {
        path: ':slug/:uid/checkout',
        name: 'Checkout',
        component: Migration
      }
    ]
  },
  {
    path: '/questionnaire/calculator/',
    component: CalculatorLayout,
    children: [
      {
        path: ':uuid?',
        name: 'Calculator',
        component: Migration
      }
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    name: '404',
    component: Error404
  }
];

export default routes;
